/* ============================================
   Poppy Creek — Conditioner Product JS
   Asset: product-conditioner.js
   ============================================ */

(function () {
  'use strict';

  // ——— Image gallery ———
  const thumbs = document.querySelectorAll('.pc-product__thumb');
  const mainImage = document.querySelector('.pc-product__image');

  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImage.src = thumb.dataset.imageSrc;
        mainImage.alt = thumb.dataset.imageAlt || '';
      });
    });
  }

  // ——— Variant switching ———
  const form = document.getElementById('product-form');
  if (!form) return;

  const variantIdInput = form.querySelector('input[name="id"]');
  const priceEl = document.getElementById('pc-price');
  const atcBtn = form.querySelector('.pc-atc');

  // Build variant map from Shopify product JSON
  const productHandle = document.querySelector('.pc-product');
  if (!productHandle) return;

  // Fetch product JSON for variant data
  const sectionEl = productHandle.dataset.sectionId;

  fetch(window.location.pathname + '.js')
    .then(function (res) { return res.json(); })
    .then(function (product) {

      const variants = product.variants;

      function getSelectedOptions() {
        const options = {};
        form.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
          options[input.name] = input.value;
        });
        return options;
      }

      function findVariant(selected) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) {
            const key = 'option-' + ['size', 'scent', 'option3'][i];
            return !selected[key] || selected[key] === opt;
          });
        });
      }

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }

      function updateUI(variant) {
        if (!variant) return;

        // Update hidden input
        if (variantIdInput) variantIdInput.value = variant.id;

        // Update price
        if (priceEl) {
          let priceHTML = '<span class="pc-price__current">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHTML += '<span class="pc-price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
          }
          priceEl.innerHTML = priceHTML;
        }

        // Update ATC button
        if (atcBtn) {
          if (variant.available) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to cart';
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = 'Sold out';
          }
        }

        // Update URL without reload
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      // Listen to all radio changes
      form.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          // Update active states on size buttons
          if (input.classList.contains('pc-size-input')) {
            document.querySelectorAll('.pc-size-btn').forEach(function (btn) {
              btn.classList.remove('is-active');
            });
            input.closest('.pc-size-btn').classList.add('is-active');
          }

          // Update active states on scent buttons
          if (input.classList.contains('pc-scent-input')) {
            document.querySelectorAll('.pc-scent-btn').forEach(function (btn) {
              btn.classList.remove('is-active');
            });
            input.closest('.pc-scent-btn').classList.add('is-active');
          }

          const selected = getSelectedOptions();
          const variant = findVariant(selected);
          if (variant) updateUI(variant);
        });
      });

    })
    .catch(function (err) {
      console.warn('Poppy Creek: could not load product variants.', err);
    });

})();